import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "row justify-center q-pa-lg"
}
const _hoisted_2 = {
  key: 1,
  class: "text-negative text-center q-pa-md"
}
const _hoisted_3 = {
  key: 2,
  class: "row q-col-gutter-md"
}
const _hoisted_4 = { class: "col-6" }
const _hoisted_5 = {
  ref: "forwardMapEl",
  style: {"height":"260px","width":"100%","border":"1px solid #ccc","border-radius":"4px"}
}
const _hoisted_6 = { class: "col-6" }
const _hoisted_7 = {
  ref: "reversedMapEl",
  style: {"height":"260px","width":"100%","border":"1px solid #ccc","border-radius":"4px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_toolbar_title = _resolveComponent("q-toolbar-title")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_toolbar = _resolveComponent("q-toolbar")!
  const _component_q_spinner = _resolveComponent("q-spinner")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!

  return (_openBlock(), _createBlock(_component_q_dialog, {
    "model-value": _ctx.modelValue,
    persistent: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_card, { style: {"width":"800px","max-width":"95vw"} }, {
        default: _withCtx(() => [
          _createVNode(_component_q_toolbar, null, {
            default: _withCtx(() => [
              _createVNode(_component_q_toolbar_title, { class: "text-blue-brand text-bold" }, {
                default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                  _createTextVNode(" Confirm Reverse Direction ", -1)
                ]))]),
                _: 1
              }),
              _createVNode(_component_q_btn, {
                flat: "",
                round: "",
                dense: "",
                icon: "close",
                onClick: _ctx.onCancel
              }, null, 8, ["onClick"])
            ]),
            _: 1
          }),
          _createVNode(_component_q_card_section, null, {
            default: _withCtx(() => [
              _cache[3] || (_cache[3] = _createElementVNode("div", { class: "text-body2 q-mb-md" }, " This will swap the launch and receive locations. The pig will run in the opposite direction along the pipeline section. ", -1)),
              (_ctx.loading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createVNode(_component_q_spinner, {
                      color: "blue-brand",
                      size: "48px"
                    })
                  ]))
                : (_ctx.errorMessage)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.errorMessage), 1))
                  : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                      _createElementVNode("div", _hoisted_4, [
                        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "text-subtitle2 text-center q-mb-sm text-weight-bold" }, " Current Direction ", -1)),
                        _createElementVNode("div", _hoisted_5, null, 512)
                      ]),
                      _createElementVNode("div", _hoisted_6, [
                        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "text-subtitle2 text-center q-mb-sm text-weight-bold" }, " Reversed Direction ", -1)),
                        _createElementVNode("div", _hoisted_7, null, 512)
                      ])
                    ]))
            ]),
            _: 1
          }),
          _createVNode(_component_q_card_actions, { align: "center" }, {
            default: _withCtx(() => [
              _createVNode(_component_q_btn, {
                "no-caps": "",
                class: "btn-brand",
                label: "Cancel",
                onClick: _ctx.onCancel
              }, null, 8, ["onClick"]),
              _createVNode(_component_q_btn, {
                "no-caps": "",
                class: "btn-brand",
                icon: "fas fa-check",
                label: "Confirm",
                disable: _ctx.loading || !!_ctx.errorMessage,
                onClick: _ctx.onConfirm
              }, null, 8, ["disable", "onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["model-value"]))
}